import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const Lock = ({ title, titleId, desc, descId }: SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 96"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id="prefix__a"
      width={96}
      height={96}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M95.4.5H.4v95h95z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fill="#3F3F3F"
        d="M10.4 24.3 34.2.5v23.8zM34.1 24.3H10.4v17.1h23.7z"
      />
      <path fill="#ED0000" d="M85.6 41.4H10.4v54.1h75.2z" />
      <path
        fill="#CFCFCF"
        d="M85.6 24.3C85.6 11.2 75 .6 61.9.6H34.2C21.1.6 10.5 11.2 10.5 24.3h51.4v17.1h23.7z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M56.5 61.4c0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5c0 3.7 2.3 6.8 5.6 8v14.5H51V69.4c3.2-1.2 5.5-4.3 5.5-8"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default Lock;
